import { Route, Routes } from "react-router"
import { NotFoundPage } from "@client/components/not-found"
import publicRoutes from "@client/modules/public/routes"
import adminRoutes from "@client/modules/admin/routes"
import donorRoutes from "@client/modules/donor/routes"

export function AppRoutes() {
  return (
    <Routes>
      {publicRoutes}
      {donorRoutes}
      {adminRoutes}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
